import { useRef } from 'react';

// Swipe left on a card to move on, right to go back a phrase, for screens
// where the arrows can be below the fold. A long result card pushed the Next chevron off the screen,
// and scrolling to find it every time is work the thumb should not have to do.
//
// Deliberately strict about what counts, because this sits on a card full of
// tappable words and scrollable text:
//  - the movement has to be mostly sideways (twice the vertical), so scrolling
//    down a long card never counts as a swipe,
//  - it has to be a real distance (SWIPE_MIN_PX), so a tap that drifts a pixel
//    or two still selects the word under it,
//  - one finger only: a two-finger gesture is a zoom, not a swipe.
const SWIPE_MIN_PX = 60;
const SIDEWAYS_RATIO = 2;

export function useSwipe({ onSwipeLeft = null, onSwipeRight = null } = {}) {
    const from = useRef(null);
    return {
        onTouchStart: (e) => {
            if (e.touches.length !== 1) { from.current = null; return; }
            const t = e.touches[0];
            from.current = { x: t.clientX, y: t.clientY };
        },
        onTouchEnd: (e) => {
            const start = from.current;
            from.current = null;
            if (!start || e.changedTouches.length !== 1) return;
            const t = e.changedTouches[0];
            const dx = t.clientX - start.x;
            const dy = t.clientY - start.y;
            if (Math.abs(dx) < SWIPE_MIN_PX || Math.abs(dx) < Math.abs(dy) * SIDEWAYS_RATIO) return;
            // Right goes back a phrase: learners asked to revisit one they had
            // just moved past (Leanne, 4 Nov 2026).
            if (dx < 0) onSwipeLeft?.();
            else onSwipeRight?.();
        },
    };
}

export default useSwipe;
